import { OrderListItem } from '@shared/model/order';

export const isExistUserRequest = (order: OrderListItem, userId: number) => {
    return order.requests.some((request) => request.user.id === userId);
};
